import { createFileRoute } from "@tanstack/react-router";
import { Terms } from "../../pages/Terms";

export const Route = createFileRoute("/_public/terms")({
  component: Terms,
});
